export default {
  API_ENDPOINT: "https://spaced-repetition-api-vb.herokuapp.com/api",
  TOKEN_KEY: process.env.REACT_APP_API_KEY || "blogful-client-auth-token",
};
